(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire07df"];
var parcelRegister = parcelRequire.register;
parcelRegister("4LSXO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6380d2989ec014a0$export$2e2bcd8739ae039; });

var $2hYdk = parcelRequire("2hYdk");

var $gDdCy = parcelRequire("gDdCy");
const $6380d2989ec014a0$var$woocommerceDataSource = ()=>{
    if (!window.transactionOrder && !window.transactionItems) return;
    try {
        const transaction = (0, $gDdCy.tryParseJSONObject)(window.transactionOrder);
        const products = (0, $gDdCy.tryParseJSONObject)(window.transactionItems);
        const email = transaction.billing.email || "N/A";
        (0, $2hYdk.default).notify({
            transactionEvent: {
                id: (transaction.id || transaction.transaction_id).toString(),
                total: parseFloat(transaction.total),
                tax: parseFloat(transaction.total_tax || 0),
                shipping: parseFloat(transaction.shipping_total || 0),
                city: (transaction.billing.city || "N/A").toString(),
                state: (transaction.billing.state || "N/A").toString(),
                country: (transaction.billing.country || "N/A").toString(),
                currency: (transaction.currency || "USD").toString(),
                userId: email,
                items: products.map((product)=>{
                    const { order_id: order_id, name: name, product_id: product_id, total: total, quantity: quantity } = product;
                    const transactionItemTotal = parseFloat(total) / quantity;
                    return {
                        orderId: (transaction.id || order_id).toString(),
                        sku: product_id.toString(),
                        name: (name || "N/A").toString(),
                        category: "N/A",
                        unitPrice: transactionItemTotal,
                        quantity: parseInt(quantity || 1),
                        currency: (transaction.currency || "USD").toString()
                    };
                })
            }
        });
    } catch (error) {
    // window.tracker('trackError', JSON.stringify(error), 'WOOCOMMERCE');
    }
};
var $6380d2989ec014a0$export$2e2bcd8739ae039 = $6380d2989ec014a0$var$woocommerceDataSource;

});
parcelRegister("gDdCy", function(module, exports) {

$parcel$export(module.exports, "tryParseJSONObject", function () { return $3314a60fcd51e41f$export$8b0f5bf83db88e; });
const $3314a60fcd51e41f$export$8b0f5bf83db88e = (event)=>{
    try {
        if (typeof event === "object") return event;
        if (typeof event === "string") return JSON.parse(event);
    } catch (e) {
        console.error("Error parsing event:", e);
    }
    return event;
};

});


})();
//# sourceMappingURL=woocommerce.f0353430.js.map
